import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-white dark:bg-gray-900" }
const _hoisted_2 = {
  for: "name",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_3 = { class: "w-full inline-flex items-space-between mt-2" }
const _hoisted_4 = { class: "w-1/2 mt-2 mr-2" }
const _hoisted_5 = {
  for: "natodaparto",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_7 = { value: "pretermine" }
const _hoisted_8 = { value: "termine" }
const _hoisted_9 = { value: "post-termine" }
const _hoisted_10 = { class: "w-1/2 mt-2" }
const _hoisted_11 = {
  for: "tipoParto",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_13 = { value: "naturale eutocico" }
const _hoisted_14 = { value: "naturale distocito" }
const _hoisted_15 = { value: "post-operatorio cesareo" }
const _hoisted_16 = { class: "w-1/2 inline-flex items-space-between mt-2" }
const _hoisted_17 = {
  for: "allattamento",
  class: "mr-2 block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_19 = { value: "materno" }
const _hoisted_20 = { value: "artificiale" }
const _hoisted_21 = { class: "w-1/2 inline-flex items-space-around mt-2" }
const _hoisted_22 = {
  for: "sviluppo:",
  class: "mr-2 block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_24 = { value: "normale" }
const _hoisted_25 = { value: "patologico" }
const _hoisted_26 = { class: "w-full inline-flex items-space-between mt-2" }
const _hoisted_27 = {
  for: "noteinfanzia",
  class: "mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_28 = { class: "w-1/2" }
const _hoisted_29 = {
  for: "scolarità",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_31 = { value: "analfabeta" }
const _hoisted_32 = { value: "elementare" }
const _hoisted_33 = { value: "medie-inferiori" }
const _hoisted_34 = { value: "diploma" }
const _hoisted_35 = { value: "laurea" }
const _hoisted_36 = { class: "w-full flex-column items-space-between mt-2" }
const _hoisted_37 = { class: "w-full mt-2 mr-2" }
const _hoisted_38 = {
  for: "attivafisica",
  class: "mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_40 = { value: "sedentario (distanza percorsa giornalmente a piedi inferiore a un km)" }
const _hoisted_41 = { value: "moderata (attività giornaliera superiore a un km, ma inferiore a mezzora di camminata\n                                veloce)" }
const _hoisted_42 = { value: "adeguata (equivalente o superiore a mezzora di camminata veloce)" }
const _hoisted_43 = { value: "sportiva (tre-sei ore di allenamento settimanali)" }
const _hoisted_44 = { value: "intensa (oltre sei ore di allenamento settimanali)" }
const _hoisted_45 = { class: "w-full mt-2" }
const _hoisted_46 = {
  for: "abitudinialimentari",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_48 = { value: "nella norma (assunzione di cibo regolare per frequenza e quantità)" }
const _hoisted_49 = { value: "inappetenza (riduzione dell' appetito, con ridotta assunzione di cibo)" }
const _hoisted_50 = { value: "anoressia (pressocchè completa o totale assenza di assunzione volontaria di cibo)" }
const _hoisted_51 = { value: "iperfagia (assunzione frequente di alimenti ed in quantità eccessiva)" }
const _hoisted_52 = { value: "bulimia (sensazione di fame continua con continua assunzione di cibo)" }
const _hoisted_53 = { class: "w-full inline-flex items-space-between mt-2" }
const _hoisted_54 = { class: "w-1/2 mt-2 mr-2" }
const _hoisted_55 = {
  for: "ritmosonoveglia",
  class: "mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_56 = { class: "w-1/2 mt-2" }
const _hoisted_57 = {
  for: "stressFisPsicologico",
  class: "block text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_59 = { value: "no" }
const _hoisted_60 = { value: "si" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full mt-2" }, null, -1)
const _hoisted_62 = { class: "w-full inline-flex items-space-between mt-2" }
const _hoisted_63 = { class: "w-1/2 mt-2 mr-2" }
const _hoisted_64 = {
  for: "fumo",
  class: "block text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_66 = { value: "no" }
const _hoisted_67 = { value: "si" }
const _hoisted_68 = {
  key: 0,
  class: "w-1/2 mt-1"
}
const _hoisted_69 = {
  for: "sigaretteal",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_70 = {
  key: 1,
  hidden: ""
}
const _hoisted_71 = {
  key: 0,
  class: "w-full inline-flex items-space-between mt-2"
}
const _hoisted_72 = { class: "w-1/2 mr-2" }
const _hoisted_73 = {
  for: "fumoInzio",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_74 = { class: "w-1/2" }
const _hoisted_75 = {
  for: "fumoFine",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_76 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full mt-2" }, null, -1)
const _hoisted_77 = { class: "w-full inline-flex items-space-between mt-2" }
const _hoisted_78 = { class: "w-1/2 mt-2 mr-2" }
const _hoisted_79 = {
  for: "alcool",
  class: "block mt-1 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_80 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_81 = { value: "no" }
const _hoisted_82 = { value: "si" }
const _hoisted_83 = {
  key: 0,
  class: "w-1/2 mt-2 mr-2"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("label", {
  for: "bicchierialgg",
  class: "block mt-1 text-sm font-medium text-gray-900 dark:text-white"
}, "Bicchieri al gg:", -1)
const _hoisted_85 = {
  key: 1,
  hidden: ""
}
const _hoisted_86 = {
  key: 2,
  class: "w-1/2 mt-2"
}
const _hoisted_87 = {
  for: "tipoAlcool",
  class: "block mb-3 mt-1 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_88 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_89 = { value: "Vino" }
const _hoisted_90 = { value: "Birra" }
const _hoisted_91 = { value: "Super alcolico" }
const _hoisted_92 = { value: "Altro" }
const _hoisted_93 = {
  key: 3,
  hidden: ""
}
const _hoisted_94 = {
  key: 1,
  class: "w-full inline-flex items-space-between"
}
const _hoisted_95 = { class: "w-1/2 mr-2" }
const _hoisted_96 = {
  for: "alcoolInzio",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_97 = {
  key: 0,
  class: "w-1/2"
}
const _hoisted_98 = {
  for: "alcoolFine",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full mt-2 mb-2" }, null, -1)
const _hoisted_100 = { class: "w-full inline-flex items-space-between mt-2" }
const _hoisted_101 = { class: "w-1/2 mt-2 mr-2" }
const _hoisted_102 = {
  for: "droghe",
  class: "block mt-1 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_103 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_104 = { value: "no" }
const _hoisted_105 = { value: "si" }
const _hoisted_106 = {
  key: 0,
  class: "w-1/2 mt-2 mr-2"
}
const _hoisted_107 = {
  for: "milligrammialgg",
  class: "block mt-1 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_108 = {
  key: 1,
  hidden: ""
}
const _hoisted_109 = {
  key: 2,
  class: "w-1/2 mt-2"
}
const _hoisted_110 = {
  for: "tipoDroghe",
  class: "block mb-3 mt-1 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_111 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_112 = { value: "Cocainaino" }
const _hoisted_113 = { value: "Anfetamina" }
const _hoisted_114 = { value: "LSD" }
const _hoisted_115 = { value: "Cannabinoidi" }
const _hoisted_116 = { value: "Metadone" }
const _hoisted_117 = { value: "MDMA" }
const _hoisted_118 = { value: "Altro" }
const _hoisted_119 = {
  key: 3,
  hidden: ""
}
const _hoisted_120 = {
  key: 2,
  class: "w-full inline-flex items-space-between"
}
const _hoisted_121 = { class: "w-1/2 mr-2" }
const _hoisted_122 = {
  for: "drogheInzio",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_123 = { class: "w-1/2" }
const _hoisted_124 = {
  for: "drogheFine",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_125 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full mt-2" }, null, -1)
const _hoisted_126 = { class: "w-full inline-flex items-space-between mt-2" }
const _hoisted_127 = { class: "w-1/2 mt-2 mr-2" }
const _hoisted_128 = {
  for: "caffeina",
  class: "block text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_130 = { value: "no" }
const _hoisted_131 = { value: "si" }
const _hoisted_132 = {
  key: 0,
  class: "w-1/2 mt-1"
}
const _hoisted_133 = {
  for: "tazzinealgg",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_134 = {
  key: 1,
  hidden: ""
}
const _hoisted_135 = /*#__PURE__*/_createElementVNode("hr", { class: "w-full mt-2 mb-2" }, null, -1)
const _hoisted_136 = { class: "w-full mt-2" }
const _hoisted_137 = {
  for: "Note",
  class: "mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_138 = {
  for: "professione",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_139 = {
  for: "note",
  class: "mt-2 block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_140 = { class: "w-1/2" }
const _hoisted_141 = {
  for: "alvo",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_142 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_143 = { value: "regolare" }
const _hoisted_144 = { value: "stitico" }
const _hoisted_145 = { value: "diarroico" }
const _hoisted_146 = { value: "alterno" }
const _hoisted_147 = { class: "w-1/2" }
const _hoisted_148 = {
  for: "minzione",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_149 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_150 = { value: "nella norma" }
const _hoisted_151 = { value: "patologica" }
const _hoisted_152 = {
  for: "note",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_153 = { class: "relative min-w-full shadow-md sm:rounded-lg" }
const _hoisted_154 = /*#__PURE__*/_createElementVNode("div", { id: "gravidanzeModal" }, null, -1)
const _hoisted_155 = {
  style: {"table-layout":"fixed"},
  class: "w-full text-sm text-left text-gray-500 dark:text-gray-400"
}
const _hoisted_156 = { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }
const _hoisted_157 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3"
}, " # ", -1)
const _hoisted_158 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_159 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_160 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_161 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_162 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_163 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_164 = {
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_165 = { key: 0 }
const _hoisted_166 = {
  scope: "row",
  class: "px-6 py-4 font-medium text-gray-900 whitespace-wrap dark:text-white"
}
const _hoisted_167 = { class: "px-6 py-4" }
const _hoisted_168 = { class: "px-6 py-4" }
const _hoisted_169 = { class: "px-6 py-4" }
const _hoisted_170 = { class: "px-6 py-4" }
const _hoisted_171 = { class: "px-6 py-4" }
const _hoisted_172 = { class: "px-6 py-4" }
const _hoisted_173 = { class: "px-6 py-4 text-right" }
const _hoisted_174 = { class: "flex justify-between" }
const _hoisted_175 = { class: "bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600" }
const _hoisted_176 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_177 = { class: "px-6 py-4" }
const _hoisted_178 = { class: "px-6 py-4" }
const _hoisted_179 = { class: "px-6 py-4" }
const _hoisted_180 = { class: "px-6 py-4 w-full" }
const _hoisted_181 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_182 = { value: "nascita" }
const _hoisted_183 = { value: "aborto" }
const _hoisted_184 = { class: "px-6 py-4 w-full" }
const _hoisted_185 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_186 = { value: "Maschio" }
const _hoisted_187 = { value: "Femmina" }
const _hoisted_188 = { class: "px-6 py-4" }
const _hoisted_189 = { class: "px-6 py-4 text-right" }
const _hoisted_190 = { class: "w-1/2" }
const _hoisted_191 = {
  for: "etamenarca",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_192 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_193 = ["value"]
const _hoisted_194 = { class: "w-1/2" }
const _hoisted_195 = {
  for: "ciclo",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_196 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_197 = { value: "regolare" }
const _hoisted_198 = { value: "iregolare" }
const _hoisted_199 = {
  for: "etamenopausa",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_200 = { class: "w-1/2" }
const _hoisted_201 = {
  for: "menopausa",
  class: "block mb-3 mt-4 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_202 = /*#__PURE__*/_createElementVNode("option", { value: "" }, null, -1)
const _hoisted_203 = { value: "fisiologica" }
const _hoisted_204 = { value: "chirurgica" }
const _hoisted_205 = {
  for: "note",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}
const _hoisted_206 = {
  key: 0,
  style: {"text-align":"center","color":"red"}
}
const _hoisted_207 = { class: "flex justify-between" }

import { onMounted, reactive } from "vue";
import { initFlowbite } from "flowbite";
import { Input } from "flowbite-vue";
import { ref } from "vue";
import { patientStore } from '@/store/patient';
import { storeToRefs } from 'pinia';
import { Tabs, Tab } from 'flowbite-vue'
import { tbl_gravidanze } from '../../../../EshJSLib/models/patient';
import { TblAnamnesiFisiologica } from '../../../../EshJSLib/models/patient';
import { delGravidanze, up_dateGravidanze, postGravidanze } from "../../../../EshJSLib/services/anamnesiServices";
import actionButton from '@/components/actionButton.vue';
import GravidanzaEdit from "./GravidanzaEdit.vue";
import { Modal } from 'flowbite-vue';
import { useRoute } from 'vue-router';
import AlertModal from "@/components/AlertModalFeedback.vue";
import ConfirmOperationModal from "@/views/Components/ConfirmOperationModal.vue";

interface ModalStatusGravidanza {
    gravidanza: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AnamnesiFisiologicaEdit',
  emits: ["cancel"],
  setup(__props, { emit }) {


const activeTab = ref(null);
const store = patientStore();
const Route = useRoute();
const { patient } = storeToRefs(store)
const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);
const confirmModal = ref<InstanceType<typeof ConfirmOperationModal> | null>(null);

const showLoading = ref(false);


const gravidanzaErrorMessage = ref("");
const gravidanzaError = ref(true);

const isShowModalG: ModalStatusGravidanza = reactive({
    gravidanza: false,
});
let index_item_gravidanza: number;
function editGravidanze(index: number): void {
    index_item_gravidanza = index;
    isShowModalG.gravidanza = true;
}

function closeModalGravidanze() {
    isShowModalG.gravidanza = false;
}

function saveGravidanze() {
    let dateFineGravidanza = new Date(tbl_gravidanzeNew.fine_gravidanza);
    let dateInizioGravidanza = new Date(tbl_gravidanzeNew.inizio_gravidanza);

    let difference = dateFineGravidanza.getMonth() - dateInizioGravidanza.getMonth();

    if (difference > 9) {
        gravidanzaErrorMessage.value = "Di norma la gravidanza termina a 9 mesi. Verifica che il valore inserito sia corretto";
        gravidanzaError.value = true;
        return;
    }


    tbl_gravidanzeNew.id_paziente = patient.value.id_paziente;
    let newGravidanza = {} as tbl_gravidanze;
    console.log(tbl_gravidanzeNew.eta);
    if (+tbl_gravidanzeNew.eta < 12 || tbl_gravidanzeNew.eta == undefined) {
        gravidanzaErrorMessage.value = "Inserire età corretta";
        return;
    }
    else {
        gravidanzaErrorMessage.value = "";
    }
    Object.assign(newGravidanza, tbl_gravidanzeNew);
    postGravidanze(newGravidanza);
    store.fetchGravidanze();
    tbl_gravidanzeNew.eta = null;
    tbl_gravidanzeNew.inizio_gravidanza = null;
    tbl_gravidanzeNew.fine_gravidanza = null;
    tbl_gravidanzeNew.note_gravidanza = null;
    tbl_gravidanzeNew.sesso_bambino = null;
    tbl_gravidanzeNew.esito = null;
    //gravidanzaError.value = false;
}

function deleteGravidanze(gravidanze: tbl_gravidanze) {
    alertModal.value.openModal("Sei sicuro di cancellare il record?", true).then((userInput) => {
        if (userInput) {
            const index = patient.value.tbl_gravidanze.indexOf(gravidanze);
            if (index !== -1) {
                patient.value.tbl_gravidanze.splice(index, 1);
                delGravidanze(gravidanze.id_gravidanza);
                store.fetchGravidanze();
            }
        }
    })

}
function updateGravidanze(gravidanze: tbl_gravidanze) {
    up_dateGravidanze(gravidanze);
    store.fetchGravidanze();
    isShowModalG.gravidanza = false;
}

let TblAnamnesiFisiologicaNew = reactive({} as TblAnamnesiFisiologica);
let TblAnamnesiFisiologicaOld = {} as TblAnamnesiFisiologica;
let tbl_gravidanzeNew = reactive({} as tbl_gravidanze);
let paz_sesso = ref();
onMounted(() => {
    initFlowbite();
    activeTab.value = 'infanzia';
    paz_sesso.value = patient.value?.paziente_sesso;

});

let isOpen = ref(false);



const loading = ref(false);
const isShowModal = reactive({
    alert: false,
    confirm: false,
});

function openConfirmationModal() {
    isShowModal.confirm = true;
}

async function saveAnamnesiFisiologica() {
    let userInput;

    patient.value.tbl_anamnesi_fisiologica.id_paziente = patient.value.id_paziente;
    patient.value.tbl_anamnesi_fisiologica.id_anamnesi_log = patient.value.id_paziente;

    userInput = await confirmModal.value?.openModal(null, true);
    if (userInput) {
        showLoading.value = true;
        try {
            await store.savePaziente("AnamnesiFisiologica", patient.value.id_paziente);
            showLoading.value = false;
            alertModal.value?.openModal("Anamnesi Fisiologica aggiornata con successo!", false);
            store.fetchAnamnesiFisiologica();
        } catch (res) {
            showLoading.value = false;
            alertModal.value?.openModal("Errore durante l'aggiornamento " + res, false);
            store.fetchAnamnesiFisiologica();
        }
    }
}

function Annula() {
    Object.assign(TblAnamnesiFisiologicaNew, TblAnamnesiFisiologicaOld);
    emit('cancel');
}


return (_ctx: any,_cache: any) => {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AlertModal, {
      ref_key: "alertModal",
      ref: alertModal
    }, null, 512),
    (showLoading.value)
      ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
      : _createCommentVNode("", true),
    (isShowModalG.gravidanza === true)
      ? (_openBlock(), _createBlock(_unref(Modal), {
          key: 1,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (isShowModalG.gravidanza = false)),
          styles: { width: '100%' }
        }, {
          body: _withCtx(() => [
            _createVNode(GravidanzaEdit, {
              onCloseGravidanze: closeModalGravidanze,
              onUpdateGravidanza: updateGravidanze,
              id: _unref(index_item_gravidanza)
            }, null, 8, ["id"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t("Modifica informazioni:")), 1)
      ]),
      _createVNode(_unref(Tabs), {
        style: {"height":"300px","overflow-y":"scroll"},
        modelValue: activeTab.value,
        "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((activeTab).value = $event)),
        class: "p-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Tab), {
            name: "infanzia",
            title: _ctx.$t('infanzia')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t("Nato da parto:")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "natodaparto",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.tempoParto) = $event)),
                    name: "natodaparto",
                    class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  }, [
                    _hoisted_6,
                    _createElementVNode("option", _hoisted_7, _toDisplayString(_ctx.$t("Pretermine")), 1),
                    _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t("Termine")), 1),
                    _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t("Post-termine")), 1)
                  ], 512), [
                    [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.tempoParto]
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("Tipo di parto:")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "tipoParto",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.tipoParto) = $event)),
                    name: "tipoParto",
                    class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  }, [
                    _hoisted_12,
                    _createElementVNode("option", _hoisted_13, _toDisplayString(_ctx.$t("Naturale Eutocico")), 1),
                    _createElementVNode("option", _hoisted_14, _toDisplayString(_ctx.$t("Naturale Distocito")), 1),
                    _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t("Post-operatorio Cesareo")), 1)
                  ], 512), [
                    [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.tipoParto]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("Allattamento:")), 1),
                _withDirectives(_createElementVNode("select", {
                  id: "allattamento",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.allattamento) = $event)),
                  name: "Allattamento",
                  class: "w-1/2 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                }, [
                  _hoisted_18,
                  _createElementVNode("option", _hoisted_19, _toDisplayString(_ctx.$t("Materno")), 1),
                  _createElementVNode("option", _hoisted_20, _toDisplayString(_ctx.$t("Artificiale")), 1)
                ], 512), [
                  [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.allattamento]
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("Sviluppo vegetativo e relazionale:")), 1),
                _withDirectives(_createElementVNode("select", {
                  id: "sviluppo",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.sviluppoVegRel) = $event)),
                  name: "sviluppo",
                  class: "w-1/2 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                }, [
                  _hoisted_23,
                  _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.$t("Normale")), 1),
                  _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.$t("Patologico")), 1)
                ], 512), [
                  [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.sviluppoVegRel]
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("noteInfanzia")), 1),
                _withDirectives(_createElementVNode("textarea", {
                  id: "noteinfanzia",
                  rows: "4",
                  class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.noteInfanzia) = $event))
                }, null, 512), [
                  [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.noteInfanzia]
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_unref(Tab), {
            name: "Scolarità",
            title: _ctx.$t('scolarità')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("Titolo conseguito:")), 1),
                _withDirectives(_createElementVNode("select", {
                  id: "scolarità",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.livelloScol) = $event)),
                  name: "scolarità",
                  class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                }, [
                  _hoisted_30,
                  _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.$t("Analfabeta")), 1),
                  _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.$t("Elementare")), 1),
                  _createElementVNode("option", _hoisted_33, _toDisplayString(_ctx.$t("Medie-inferiori")), 1),
                  _createElementVNode("option", _hoisted_34, _toDisplayString(_ctx.$t("Diploma")), 1),
                  _createElementVNode("option", _hoisted_35, _toDisplayString(_ctx.$t("Laurea")), 1)
                ], 512), [
                  [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.livelloScol]
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_unref(Tab), {
            name: "Stiledivita",
            title: _ctx.$t('stileDiVita')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t("Attività fisica:")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "attivafisica",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.attivitaFisica) = $event)),
                    name: "attivafisica",
                    class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  }, [
                    _hoisted_39,
                    _createElementVNode("option", _hoisted_40, _toDisplayString(_ctx.$t("sedentario")), 1),
                    _createElementVNode("option", _hoisted_41, _toDisplayString(_ctx.$t("moderata")), 1),
                    _createElementVNode("option", _hoisted_42, _toDisplayString(_ctx.$t("adeguata")), 1),
                    _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.$t("sportiva")), 1),
                    _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.$t("intensa")), 1)
                  ], 512), [
                    [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.attivitaFisica]
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t("Abitudini alimentari:")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "abitudinialimentari",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.abitudAlim) = $event)),
                    name: "abitudinialimentari",
                    class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  }, [
                    _hoisted_47,
                    _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.$t("nellaNorma")), 1),
                    _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.$t("inappetenza")), 1),
                    _createElementVNode("option", _hoisted_50, _toDisplayString(_ctx.$t("anoressia")), 1),
                    _createElementVNode("option", _hoisted_51, _toDisplayString(_ctx.$t("iperfagia")), 1),
                    _createElementVNode("option", _hoisted_52, _toDisplayString(_ctx.$t("bulimia")), 1)
                  ], 512), [
                    [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.abitudAlim]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("label", _hoisted_55, _toDisplayString(_ctx.$t("ritmoSonoVeglia")), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    id: "ritmosonoveglia",
                    rows: "1",
                    class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                    placeholder: "",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.ritmoSV) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.ritmoSV]
                  ])
                ]),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("label", _hoisted_57, _toDisplayString(_ctx.$t("Stress fisico e psicologico:")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "stressFisPsicologico",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.stress) = $event)),
                    name: "stressFisPsicologico",
                    class: "w-full mt-1 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  }, [
                    _hoisted_58,
                    _createElementVNode("option", _hoisted_59, _toDisplayString(_ctx.$t("no")), 1),
                    _createElementVNode("option", _hoisted_60, _toDisplayString(_ctx.$t("si")), 1)
                  ], 512), [
                    [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.stress]
                  ])
                ])
              ]),
              _hoisted_61,
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("label", _hoisted_64, _toDisplayString(_ctx.$t("Fumo:")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "fumo",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.fumo) = $event)),
                    name: "fumo",
                    class: "w-full mt-1 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  }, [
                    _hoisted_65,
                    _createElementVNode("option", _hoisted_66, _toDisplayString(_ctx.$t("no")), 1),
                    _createElementVNode("option", _hoisted_67, _toDisplayString(_ctx.$t("si")), 1)
                  ], 512), [
                    [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.fumo]
                  ])
                ]),
                (_unref(patient).tbl_anamnesi_fisiologica.fumo === 'si')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                      _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t("cigateresGG")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "sigaretteal",
                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                        placeholder: "",
                        required: "",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.dosiFumo) = $event))
                      }, null, 512), [
                        [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.dosiFumo]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_unref(patient).tbl_anamnesi_fisiologica.dosiFumo=0), 1))
              ]),
              (_unref(patient).tbl_anamnesi_fisiologica.fumo === 'si')
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                    _createElementVNode("div", _hoisted_72, [
                      _createElementVNode("label", _hoisted_73, _toDisplayString(_ctx.$t("Inizio :")), 1),
                      _withDirectives(_createElementVNode("input", {
                        for: "fumoInzio",
                        type: "date",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.dataInizioFumo) = $event)),
                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      }, null, 512), [
                        [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.dataInizioFumo]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t("Fine :")), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "fumoFine",
                        type: "date",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.dataFineFumo) = $event)),
                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      }, null, 512), [
                        [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.dataFineFumo]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_76,
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("label", _hoisted_79, _toDisplayString(_ctx.$t("Alcool:")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "alcool",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.alcool) = $event)),
                    name: "alcool",
                    class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  }, [
                    _hoisted_80,
                    _createElementVNode("option", _hoisted_81, _toDisplayString(_ctx.$t("no")), 1),
                    _createElementVNode("option", _hoisted_82, _toDisplayString(_ctx.$t("si")), 1)
                  ], 512), [
                    [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.alcool]
                  ])
                ]),
                (_unref(patient).tbl_anamnesi_fisiologica.alcool === 'si')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _hoisted_84,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "sigarbicchierialggetteal",
                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                        placeholder: "",
                        required: "",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.dosiAlcool) = $event))
                      }, null, 512), [
                        [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.dosiAlcool]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_85, _toDisplayString(_unref(patient).tbl_anamnesi_fisiologica.dosiAlcool=0), 1)),
                (_unref(patient).tbl_anamnesi_fisiologica.alcool === 'si')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                      _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t("Tipo :")), 1),
                      _withDirectives(_createElementVNode("select", {
                        id: "tipoAlcool",
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.tipoAlcool) = $event)),
                        name: "tipoAlcool",
                        class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      }, [
                        _hoisted_88,
                        _createElementVNode("option", _hoisted_89, _toDisplayString(_ctx.$t("vino")), 1),
                        _createElementVNode("option", _hoisted_90, _toDisplayString(_ctx.$t("birra")), 1),
                        _createElementVNode("option", _hoisted_91, _toDisplayString(_ctx.$t("superAlcolico")), 1),
                        _createElementVNode("option", _hoisted_92, _toDisplayString(_ctx.$t("altro")), 1)
                      ], 512), [
                        [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.tipoAlcool]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_93, _toDisplayString(_unref(patient).tbl_anamnesi_fisiologica.tipoAlcool=""), 1))
              ]),
              (_unref(patient).tbl_anamnesi_fisiologica.alcool === 'si')
                ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                    _createElementVNode("div", _hoisted_95, [
                      _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.$t("Inizio :")), 1),
                      _withDirectives(_createElementVNode("input", {
                        for: "alcoolInzio",
                        type: "date",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.dataInizioAlcool) = $event)),
                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      }, null, 512), [
                        [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.dataInizioAlcool]
                      ])
                    ]),
                    (_unref(patient).tbl_anamnesi_fisiologica.alcool === 'si')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                          _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t("Fine :")), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "fumoFine",
                            type: "date",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.dataFineAlcool) = $event)),
                            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                          }, null, 512), [
                            [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.dataFineAlcool]
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _hoisted_99,
              _createElementVNode("div", _hoisted_100, [
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.$t("droghe")) + ":", 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "droghe",
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.droghe) = $event)),
                    name: "droghe",
                    class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  }, [
                    _hoisted_103,
                    _createElementVNode("option", _hoisted_104, _toDisplayString(_ctx.$t("no")), 1),
                    _createElementVNode("option", _hoisted_105, _toDisplayString(_ctx.$t("si")), 1)
                  ], 512), [
                    [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.droghe]
                  ])
                ]),
                (_unref(patient).tbl_anamnesi_fisiologica.droghe === 'si')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_106, [
                      _createElementVNode("label", _hoisted_107, _toDisplayString(_ctx.$t("drogheGG")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "milligrammialgg",
                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                        placeholder: "",
                        required: "",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.dosiDroghe) = $event))
                      }, null, 512), [
                        [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.dosiDroghe]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_108, _toDisplayString(_unref(patient).tbl_anamnesi_fisiologica.dosiDroghe=0), 1)),
                (_unref(patient).tbl_anamnesi_fisiologica.droghe === 'si')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_109, [
                      _createElementVNode("label", _hoisted_110, _toDisplayString(_ctx.$t("Tipo :")), 1),
                      _withDirectives(_createElementVNode("select", {
                        id: "tipoDroghe",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.tipoDroghe) = $event)),
                        name: "tipoDroghe",
                        class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      }, [
                        _hoisted_111,
                        _createElementVNode("option", _hoisted_112, _toDisplayString(_ctx.$t("cocaina")), 1),
                        _createElementVNode("option", _hoisted_113, _toDisplayString(_ctx.$t("anfetamina")), 1),
                        _createElementVNode("option", _hoisted_114, _toDisplayString(_ctx.$t("LSD")), 1),
                        _createElementVNode("option", _hoisted_115, _toDisplayString(_ctx.$t("cannabinoidi")), 1),
                        _createElementVNode("option", _hoisted_116, _toDisplayString(_ctx.$t("metadone")), 1),
                        _createElementVNode("option", _hoisted_117, _toDisplayString(_ctx.$t("MDMA")), 1),
                        _createElementVNode("option", _hoisted_118, _toDisplayString(_ctx.$t("altro")), 1)
                      ], 512), [
                        [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.tipoDroghe]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_119, _toDisplayString(_unref(patient).tbl_anamnesi_fisiologica.tipoDroghe=""), 1))
              ]),
              (_unref(patient).tbl_anamnesi_fisiologica.droghe === 'si')
                ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                    _createElementVNode("div", _hoisted_121, [
                      _createElementVNode("label", _hoisted_122, _toDisplayString(_ctx.$t("Inizio :")), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "drogheInzio",
                        type: "date",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.dataInizioDroghe) = $event)),
                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      }, null, 512), [
                        [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.dataInizioDroghe]
                      ]),
                      _createTextVNode("- ")
                    ]),
                    _createElementVNode("div", _hoisted_123, [
                      _createElementVNode("label", _hoisted_124, _toDisplayString(_ctx.$t("Fine :")), 1),
                      _withDirectives(_createElementVNode("input", {
                        id: "drogheFine",
                        type: "date",
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.dataFineDroghe) = $event)),
                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                      }, null, 512), [
                        [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.dataFineDroghe]
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_125,
              _createElementVNode("div", _hoisted_126, [
                _createElementVNode("div", _hoisted_127, [
                  _createElementVNode("label", _hoisted_128, _toDisplayString(_ctx.$t("Caffeina :")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "caffeina",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.caffeina) = $event)),
                    name: "caffeina",
                    class: "w-full mt-1 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                  }, [
                    _hoisted_129,
                    _createElementVNode("option", _hoisted_130, _toDisplayString(_ctx.$t("no")), 1),
                    _createElementVNode("option", _hoisted_131, _toDisplayString(_ctx.$t("si")), 1)
                  ], 512), [
                    [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.caffeina]
                  ])
                ]),
                (_unref(patient).tbl_anamnesi_fisiologica.caffeina === 'si')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_132, [
                      _createElementVNode("label", _hoisted_133, _toDisplayString(_ctx.$t("tazzinealgg")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "tazzinealgg",
                        class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                        placeholder: "",
                        required: "",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.dosiCaffeina) = $event))
                      }, null, 512), [
                        [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.dosiCaffeina]
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_134, _toDisplayString(_unref(patient).tbl_anamnesi_fisiologica.dosiCaffeina=0), 1))
              ]),
              _hoisted_135,
              _createElementVNode("div", _hoisted_136, [
                _createElementVNode("label", _hoisted_137, _toDisplayString(_ctx.$t("Note")), 1),
                _withDirectives(_createElementVNode("textarea", {
                  id: "Note",
                  rows: "2",
                  class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.noteStileVita) = $event)),
                  placeholder: ""
                }, null, 512), [
                  [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.noteStileVita]
                ])
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_unref(Tab), {
            name: "Attivitàlavorativa",
            title: _ctx.$t('attivitaLavorativa')
          }, {
            default: _withCtx(() => [
              _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.$t("professione")), 1),
              _withDirectives(_createElementVNode("textarea", {
                id: "professione",
                rows: "4",
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.professione) = $event)),
                class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                placeholder: ""
              }, null, 512), [
                [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.professione]
              ]),
              _createElementVNode("label", _hoisted_139, _toDisplayString(_ctx.$t("Note")), 1),
              _withDirectives(_createElementVNode("textarea", {
                id: "note",
                rows: "4",
                class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.noteAttLav) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.noteAttLav]
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          _createVNode(_unref(Tab), {
            name: "Alvoeminzione",
            title: _ctx.$t('alvoMinzione')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_140, [
                _createElementVNode("label", _hoisted_141, _toDisplayString(_ctx.$t("Alvo:")), 1),
                _withDirectives(_createElementVNode("select", {
                  id: "alvo",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.alvo) = $event)),
                  name: "alvo",
                  class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                }, [
                  _hoisted_142,
                  _createElementVNode("option", _hoisted_143, _toDisplayString(_ctx.$t("regolare")), 1),
                  _createElementVNode("option", _hoisted_144, _toDisplayString(_ctx.$t("stitico")), 1),
                  _createElementVNode("option", _hoisted_145, _toDisplayString(_ctx.$t("diarroico")), 1),
                  _createElementVNode("option", _hoisted_146, _toDisplayString(_ctx.$t("alterno")), 1)
                ], 512), [
                  [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.alvo]
                ])
              ]),
              _createElementVNode("div", _hoisted_147, [
                _createElementVNode("label", _hoisted_148, _toDisplayString(_ctx.$t("Minzione :")), 1),
                _withDirectives(_createElementVNode("select", {
                  id: "minzione",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.minzione) = $event)),
                  name: "minzione",
                  class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                }, [
                  _hoisted_149,
                  _createElementVNode("option", _hoisted_150, _toDisplayString(_ctx.$t("NellaNorma")), 1),
                  _createElementVNode("option", _hoisted_151, _toDisplayString(_ctx.$t("patologica")), 1)
                ], 512), [
                  [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.minzione]
                ])
              ]),
              _createElementVNode("label", _hoisted_152, _toDisplayString(_ctx.$t("Note")), 1),
              _withDirectives(_createElementVNode("textarea", {
                id: "note",
                rows: "4",
                class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.noteAlvoMinz) = $event)),
                placeholder: ""
              }, null, 512), [
                [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.noteAlvoMinz]
              ])
            ]),
            _: 1
          }, 8, ["title"]),
          (_unref(paz_sesso) == "female")
            ? (_openBlock(), _createBlock(_unref(Tab), {
                key: 0,
                name: "gravidanze",
                title: _ctx.$t('Gravidanze')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_153, [
                    _hoisted_154,
                    _createElementVNode("table", _hoisted_155, [
                      _createElementVNode("thead", _hoisted_156, [
                        _createElementVNode("tr", null, [
                          _hoisted_157,
                          _createElementVNode("th", _hoisted_158, _toDisplayString(_ctx.$t("Eta")), 1),
                          _createElementVNode("th", _hoisted_159, _toDisplayString(_ctx.$t("Inizio")), 1),
                          _createElementVNode("th", _hoisted_160, _toDisplayString(_ctx.$t("Fine")), 1),
                          _createElementVNode("th", _hoisted_161, _toDisplayString(_ctx.$t("Esito")), 1),
                          _createElementVNode("th", _hoisted_162, _toDisplayString(_ctx.$t("Sesso")), 1),
                          _createElementVNode("th", _hoisted_163, _toDisplayString(_ctx.$t("Note")), 1),
                          _createElementVNode("th", _hoisted_164, _toDisplayString(_ctx.$t("Opzioni")), 1)
                        ])
                      ]),
                      (_unref(patient).tbl_gravidanze != null)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_165, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).tbl_gravidanze, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                class: "bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600",
                                key: index
                              }, [
                                _createElementVNode("td", _hoisted_166, _toDisplayString(index + 1), 1),
                                _createElementVNode("td", _hoisted_167, _toDisplayString(item?.eta), 1),
                                _createElementVNode("td", _hoisted_168, _toDisplayString(item?.inizio_gravidanza?.toString().substring(0, 10)), 1),
                                _createElementVNode("td", _hoisted_169, _toDisplayString(item?.fine_gravidanza?.toString().substring(0, 10)), 1),
                                _createElementVNode("td", _hoisted_170, _toDisplayString(item?.esito), 1),
                                _createElementVNode("td", _hoisted_171, _toDisplayString(item?.sesso_bambino), 1),
                                _createElementVNode("td", _hoisted_172, _toDisplayString(item?.note_gravidanza), 1),
                                _createElementVNode("td", _hoisted_173, [
                                  _createElementVNode("div", _hoisted_174, [
                                    _createVNode(actionButton, {
                                      ref_for: true,
                                      ref: "edit",
                                      iconname: "pen",
                                      style: {"font-size":"35px","margin-right":"22px"},
                                      onClick: ($event: any) => (editGravidanze(index))
                                    }, null, 8, ["onClick"]),
                                    _createVNode(actionButton, {
                                      ref_for: true,
                                      ref: "delete",
                                      iconname: "trash",
                                      style: {"font-size":"35px","margin-right":"22px"},
                                      onClick: ($event: any) => (deleteGravidanze(item))
                                    }, null, 8, ["onClick"])
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("tfoot", null, [
                        _createElementVNode("tr", _hoisted_175, [
                          _hoisted_176,
                          _createElementVNode("td", _hoisted_177, [
                            _withDirectives(_createElementVNode("input", {
                              ref: "etaGrav",
                              type: "number",
                              min: "1",
                              id: "etaBambino",
                              class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                              placeholder: "ETÀ",
                              required: "",
                              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_unref(tbl_gravidanzeNew).eta) = $event))
                            }, null, 512), [
                              [_vModelText, _unref(tbl_gravidanzeNew).eta]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_178, [
                            _withDirectives(_createElementVNode("input", {
                              ref: "inizioGravidanza",
                              type: "date",
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(tbl_gravidanzeNew).inizio_gravidanza) = $event)),
                              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                            }, null, 512), [
                              [_vModelText, _unref(tbl_gravidanzeNew).inizio_gravidanza]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_179, [
                            _withDirectives(_createElementVNode("input", {
                              ref: "fineGravidanza",
                              type: "date",
                              "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_unref(tbl_gravidanzeNew).fine_gravidanza) = $event)),
                              class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                            }, null, 512), [
                              [_vModelText, _unref(tbl_gravidanzeNew).fine_gravidanza]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_180, [
                            _withDirectives(_createElementVNode("select", {
                              ref: "essito",
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(tbl_gravidanzeNew).esito) = $event)),
                              name: "essito",
                              class: "min-w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                            }, [
                              _hoisted_181,
                              _createElementVNode("option", _hoisted_182, _toDisplayString(_ctx.$t("nascita")), 1),
                              _createElementVNode("option", _hoisted_183, _toDisplayString(_ctx.$t("aborto")), 1)
                            ], 512), [
                              [_vModelSelect, _unref(tbl_gravidanzeNew).esito]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_184, [
                            _withDirectives(_createElementVNode("select", {
                              ref: "sessoBambino",
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_unref(tbl_gravidanzeNew).sesso_bambino) = $event)),
                              name: "sessoBamino",
                              class: "min-w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                            }, [
                              _hoisted_185,
                              _createElementVNode("option", _hoisted_186, _toDisplayString(_ctx.$t("Maschio")), 1),
                              _createElementVNode("option", _hoisted_187, _toDisplayString(_ctx.$t("Femmina")), 1)
                            ], 512), [
                              [_vModelSelect, _unref(tbl_gravidanzeNew).sesso_bambino]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_188, [
                            _withDirectives(_createElementVNode("textarea", {
                              ref: "noteGravidanza",
                              rows: "1",
                              class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(tbl_gravidanzeNew).note_gravidanza) = $event)),
                              placeholder: ""
                            }, null, 512), [
                              [_vModelText, _unref(tbl_gravidanzeNew).note_gravidanza]
                            ])
                          ]),
                          _createElementVNode("td", _hoisted_189, [
                            _createVNode(actionButton, {
                              iconname: "plus",
                              style: {"font-size":"35px","margin-right":"22px"},
                              onClick: saveGravidanze
                            })
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          (_unref(paz_sesso) == "female")
            ? (_openBlock(), _createBlock(_unref(Tab), {
                key: 1,
                name: "ciclomestruale",
                title: _ctx.$t('ciclomestruale')
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_190, [
                    _createElementVNode("label", _hoisted_191, _toDisplayString(_ctx.$t("Età menarca:")), 1),
                    _withDirectives(_createElementVNode("select", {
                      id: "etamenarca",
                      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.etaMenarca) = $event)),
                      name: "etamenarca",
                      class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    }, [
                      _hoisted_192,
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList([8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18], (item, index) => {
                        return _createElementVNode("option", {
                          value: item,
                          key: index
                        }, _toDisplayString(item), 9, _hoisted_193)
                      }), 64))
                    ], 512), [
                      [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.etaMenarca]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_194, [
                    _createElementVNode("label", _hoisted_195, _toDisplayString(_ctx.$t("Ciclo :")), 1),
                    _withDirectives(_createElementVNode("select", {
                      id: "ciclo",
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.ciclo) = $event)),
                      name: "ciclo",
                      class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    }, [
                      _hoisted_196,
                      _createElementVNode("option", _hoisted_197, _toDisplayString(_ctx.$t("Regolare")), 1),
                      _createElementVNode("option", _hoisted_198, _toDisplayString(_ctx.$t("Irregolare")), 1)
                    ], 512), [
                      [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.ciclo]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_199, _toDisplayString(_ctx.$t("etaMenopausa")), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    id: "etamenopausa",
                    rows: "4",
                    class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                    "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.etaMenopausa) = $event)),
                    placeholder: "Età"
                  }, null, 512), [
                    [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.etaMenopausa]
                  ]),
                  _createElementVNode("div", _hoisted_200, [
                    _createElementVNode("label", _hoisted_201, _toDisplayString(_ctx.$t("Menopausa:")), 1),
                    _withDirectives(_createElementVNode("select", {
                      id: "menopausa",
                      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.menopausa) = $event)),
                      name: "menopausa",
                      class: "w-full bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                    }, [
                      _hoisted_202,
                      _createElementVNode("option", _hoisted_203, _toDisplayString(_ctx.$t("Fisiologica")), 1),
                      _createElementVNode("option", _hoisted_204, _toDisplayString(_ctx.$t("Chirurgica")), 1)
                    ], 512), [
                      [_vModelSelect, _unref(patient).tbl_anamnesi_fisiologica.menopausa]
                    ])
                  ]),
                  _createElementVNode("label", _hoisted_205, _toDisplayString(_ctx.$t("Note")), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    id: "note",
                    rows: "4",
                    class: "block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500",
                    "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_unref(patient).tbl_anamnesi_fisiologica.noteCicloMes) = $event)),
                    placeholder: ""
                  }, null, 512), [
                    [_vModelText, _unref(patient).tbl_anamnesi_fisiologica.noteCicloMes]
                  ])
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(AlertModal, {
        ref_key: "alertModal",
        ref: alertModal
      }, null, 512),
      _createVNode(ConfirmOperationModal, {
        ref_key: "confirmModal",
        ref: confirmModal
      }, null, 512),
      (gravidanzaError.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_206, _toDisplayString(gravidanzaErrorMessage.value), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_207, [
      _createElementVNode("button", {
        onClick: Annula,
        class: "mt-4 text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
      }, _toDisplayString(_ctx.$t("Annulla")), 1),
      _createElementVNode("button", {
        type: "button",
        onClick: saveAnamnesiFisiologica,
        style: {"float":"right","background-color":"#1A576E"},
        class: "mt-4 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      }, _toDisplayString(_ctx.$t("Salva")), 1)
    ])
  ], 64))
}
}

})